import {SourceData} from '../../../ui/map';
import {GEO_TILES_URI_PREFIX, PARCEL_LAYER_MIN_ZOOM} from '../../../constants';

export enum Id {
	DoNotMailParcel = 'id_lb-do-not-mail-parcel-source',
	DoNotMailParcelCentroid = 'id_lb-do-not-mail-parcel-centroid-source',
	Filter = 'id_lb-filter-source',
	Parcel = 'id_lb-parcel-source',
}

interface ISource {
	id: string;
	source: SourceData;
}

export const PROJECT_SCOPED_PARCEL_TILES_ENABLED = true;

export function parcelTileUrl(projectSlug: string, revision: number = 0): string {
	if (PROJECT_SCOPED_PARCEL_TILES_ENABLED && projectSlug.length > 0) {
		const params = new URLSearchParams({project: projectSlug});
		if (revision > 0) {
			params.set('rev', String(revision));
		}
		return `${GEO_TILES_URI_PREFIX}/{z}/{x}/{y}/?${params.toString()}`;
	}
	return `${GEO_TILES_URI_PREFIX}/{z}/{x}/{y}/`;
}

export function parcelFilterTileUrl(projectSlug: string, filterId: number, revision: number = 0): string {
	const params = new URLSearchParams({
		filter: String(filterId),
		project: projectSlug,
	});
	if (revision > 0) {
		params.set('rev', String(revision));
	}
	return `${GEO_TILES_URI_PREFIX}/{z}/{x}/{y}/?${params.toString()}`;
}

export function parcelFilterSource(projectSlug: string, filterId: number, revision: number = 0): SourceData {
	return {
		minzoom: PARCEL_LAYER_MIN_ZOOM,
		promoteId: 'area_pk',
		tiles: [
			parcelFilterTileUrl(projectSlug, filterId, revision),
		],
		type: 'vector',
	};
}

export function sources(projectSlug: string = '', parcelTileRevision: number = 0): Array<ISource> {
	return [
	// NB: DO NOT RE-ORDER
	{
		id: Id.Parcel,
		source: {
			minzoom: PARCEL_LAYER_MIN_ZOOM,
			promoteId: 'area_pk',
			tiles: [
				parcelTileUrl(projectSlug, parcelTileRevision),
			],
			type: 'vector',
		},
	},
	{
		id: Id.Filter,
		source: {
			data: {
				features: [],
				type: 'FeatureCollection',
			},
			generateId: true,
			type: 'geojson',
		},
	},
	{
		source: {
			data: {
				features: [],
				type: 'FeatureCollection',
			},
			generateId: true,
			type: 'geojson',
		},
		id: Id.DoNotMailParcel,
	},
	{
		source: {
			cluster: true,
			clusterMaxZoom: 13,
			clusterRadius: 50,
			data: {
				features: [],
				type: 'FeatureCollection',
			},
			generateId: true,
			type: 'geojson',
		},
		id: Id.DoNotMailParcelCentroid,
	},
	];
}
